import { Component, Element, h, Prop } from '@stencil/core';
import { injectCSS } from '../../utils';
import { createStyles } from './flex-styles';
import {
  TFlexAlignContent,
  TFlexAlignItem,
  TFlexDirection,
  TFlexJustifyContent,
  TFlexGutterSize,
  TFlexWrap,
  TFlexInline,
} from './flex-utils';

@Component({
  tag: 'dc-ui-flex',
  shadow: true,
})
export class DcUiFlex {
  /** Host element */
  @Element() host!: HTMLElement;
  /** Defines the direction of the main and cross axis */
  @Prop() direction?: TFlexDirection = 'row';
  /** Wrapping behavior of items */
  @Prop() wrap?: TFlexWrap = 'nowrap';
  /** Defines the gutter size */
  @Prop() gutter?: TFlexGutterSize = 0;
  /** This aligns a flex container's individual lines when there is extra space in the cross-axis, similar to how 'justifyContent' aligns individual items along the main axis. */
  @Prop() alignContent?: TFlexAlignContent = 'stretch';
  /** Defines how the flex items are aligned along the cross axis. */
  @Prop() alignItems?: TFlexAlignItem = 'stretch';
  /** Defines how the flex items are aligned along the main axis. */
  @Prop() justifyContent?: TFlexJustifyContent = 'flex-start';
  /** Defines the flex containers content flow if 2 or more containers are siblings of each other. */
  @Prop() inline?: TFlexInline = false;

  render() {
    injectCSS(
      this.host,
      createStyles,
      this.inline,
      this.direction,
      this.wrap,
      this.gutter,
      this.alignContent,
      this.alignItems,
      this.justifyContent
    );

    return <slot />;
  }
}
